
import React from "react"
import NewDynamicTable from "../../shared/NewDynamicTable";
import { useState } from "react";
import { useEffect } from "react";
import { getBalancesReport } from "../../../networking/NetworkingQPS";
import NewEditableGrid from "../../shared/NewEditableGrid";

const  BalancesScreen = () => {

    const systemDate= localStorage.getItem('SystemDate');
    const [balances, setBalances]= useState([]);

    useEffect(() => {
        loadReport();
    },[]);

    const loadReport = async () => {
            const balancesResponse = await getBalancesReport();
            setBalances(balancesResponse.balances??[]);
    }

return (<>
            <div className="uk-grid">

                <div  className="uk-width-1-12 uk-form-controls">
                    <label className="uk-form-label">{'Balances to :'}</label>
                </div> 

                <div  className="uk-width-1-8 uk-form-controls">
                    <label className="uk-form-label">{systemDate}</label>
                </div> 

            </div>
            <div className="uk-grid">
                <div  className="uk-width-1-1 uk-form-controls">
                    <NewDynamicTable 
                        data={balances}
                        enableSortByHeader = {true}
                        useExportButton={true}
                        tableName="Balances"
                        />
                </div> 
            </div>

    </>)
}

export default BalancesScreen